'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isSymbol(value) {
    return typeof value === 'symbol';
}

exports.isSymbol = isSymbol;
